import { render, staticRenderFns } from "./NoiseArticle.vue?vue&type=template&id=47e835c9&"
import script from "./NoiseArticle.vue?vue&type=script&lang=js&"
export * from "./NoiseArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports